export const documentsDic = {
  0: { name: "BOLETA_HONORARIOS", label: "B-Hon", fullName: 'Boleta de Honorarios',  isDocumentCodeInUse: true },
  33: { name: "FACTURA_ELECTRONICA", label: "F-Ele", fullName: 'Factura Electrónica', isDocumentCodeInUse: true },
  34: { name: "FACTURA_EXENTA", label: "F-Exe", fullName: 'Factura Electrónica Exenta', isDocumentCodeInUse: true },
  45: { name: "FACTURA_COMPRA", label: "F-Com", isDocumentCodeInUse: false },
  52: { name: "GUIA_DESPACHO", label: "G-Des", isDocumentCodeInUse: false },
  61: { name: "NOTA_CREDITO", label: "N-Cre", fullName: 'Nota de Crédito Electrónica', isDocumentCodeInUse: true },
  56: { name: "NOTA_DEBITO", label: "N-Deb", fullName: 'Nota de Débito Electrónica', isDocumentCodeInUse: true },
  30: { name: "FACTURA", label: "Fac", isDocumentCodeInUse: false },
  32: { name: "FACTURA_DE_VENTAS_EXENTA", label: "F-Ve", isDocumentCodeInUse: false },
  35: { name: "BOLETA", label: "Bol", isDocumentCodeInUse: false },
  38: { name: "BOLETA_EXENTA", label: "B-Exe", isDocumentCodeInUse: false },
  39: { name: "BOLETA_ELECTRONICA", label: "B-Ele", isDocumentCodeInUse: false },
  40: { name: "LIQUIDACION_FACTURA", label: "L-Fac", isDocumentCodeInUse: false },
  41: { name: "BOLETA_EXENTA_ELECTRONICA", label: "B-Exe", isDocumentCodeInUse: false },
  43: { name: "LIQUIDACION_FACTURA_ELECTRONICA", label: "L-Fac", isDocumentCodeInUse: false },
  46: { name: "FACTURA_DE_COMPRA_ELECTRONICA", label: "F-Com", fullName: 'Factura de Compra Electrónica', isDocumentCodeInUse: true },
  48: { name: "PAGO_ELECTRONICO", label: "P-Ele", isDocumentCodeInUse: false },
  50: { name: "GUIA_DE_DESPACHO", label: "G-Des", isDocumentCodeInUse: false },
  55: { name: "NOTA_DE_DEBITO", label: "N-Deb", isDocumentCodeInUse: false },
  60: { name: "NOTA_DE_CREDITO", label: "N-Cre", isDocumentCodeInUse: false },
  103: { name: "LIQUIDACION", label: "Liq", isDocumentCodeInUse: false },
  110: { name: "FACTURA_DE_EXPORTACION_ELECTRONICA", label: "F-Exp", fullName: 'Factura de Exportación Electrónica', isDocumentCodeInUse: true },
  111: { name: "NOTA_DE_DEBITO_DE_EXPORTACION_ELECTRONICA", label: "N-DebEx", fullName: 'Nota de Débito de Exportación Electrónica ', isDocumentCodeInUse: true },
  112: { name: "NOTA_DE_CREDITO_DE_EXPORTACION_ELECTRONICA", label: "N-CreEx", fullName: 'Nota de Crédito de Exportación Electrónica', isDocumentCodeInUse: true },
  914: { name: "DECLARACION_DE_INGRESOS", label: "Din", isDocumentCodeInUse: false },
  O: { name: "OBLIGACION", label: "Oblig", isDocumentCodeInUse: false },
  1000: { name: "OBLIGACION", label: "Oblig", fullName: 'Obligación', isDocumentCodeInUse: false },
  acountsMovement: { name: "Traspaso entre cuentas", label: "T-Cue" },
  thirdPartyPayment: { name: "Pagado por un tercero", label: "P-Ter" },
  partnerLoan: { name: "Prestamo socio", label: "P-Soc" },
  stockMovement: { name: "Aporte/Retiro capital", label: "A/R-Cap" },
  factura_venta: { name: "FACTURA_DE_VENTAS", label: "F-Ve" },
  factura_exenta: { name: "FACTURA_EXENTA", label: "F-Exe" },
  fondo_por_rendir: { name: "Fondo por Rendir", label: "Fond-Rend" },
  fondo_recibido_por_rendir: {
    name: "Fondo Recibido por Rendir",
    label: "Fond-Rend",
  },
  gasto_anticipado: { name: "Gasto Anticipado", label: "Gast-Ant" },
  gasto_anticipado_transbank_credito: {
    name: "Gasto Anticipado Transbank Crédito",
    label: "Gast-Ant",
  },
  gasto_anticipado_transbank_debito: {
    name: "Gasto Anticipado Transbank Débito",
    label: "Gast-Ant",
  },
  regularizacion_bancaria: {
    name: "Regularización Bancaria",
    label: "Reg-Banc",
  },
  capital: { name: "Capital", label: "Cap" },
  interes: { name: "Interés", label: "Int" },
  interes_por_mora: { name: "Interés por mora", label: "Int-Mora" },
  impuesto_timbre_y_estampilla: {
    name: "Impuesto timbre y estampilla",
    label: "Imp-TyE",
  },
  prestamo: { name: "Préstamo", label: "Prest" },
  afp_inp: { name: "AFP / INP", label: "AFP" },
  apv: { name: "APV", label: "APV" },
  isapre_fonasa: { name: "Isapre / Fonasa", label: "Prev" },
  afc: { name: "AFC", label: "AFC" },
  mutuales_seguridad: { name: "Mutuales de Seguridad", label: "Mut-Seg" },
  impuesto_2ª_categoria: { name: "Impuesto 2ª Categoría", label: "Imp-2°" },
  otros_descuentos: { name: "Otros Descuentos", label: "Otr-Desc" },
  anticipos: { name: "Anticipos", label: "Antic" },
  sueldos: { name: "Sueldos", label: "Sueld" },
  aguinaldos: { name: "Aguinaldos", label: "Aguin" },
  finiquitos: { name: "Finiquitos", label: "Finiq" },
  caja_compensacion: { name: "Caja de Compensación", label: "Caja-Co" },
  pago_provisional_mensual: {
    name: "Pago Provisional Mensual",
    label: "Prev-Men",
  },
  iva_debito_credito: { name: "IVA Débito / Crédito", label: "Iva-T" },
  remanente_credito_fiscal: {
    name: "Remanente Crédito Fiscal",
    label: "Rem-Cred",
  },
  iva_debito_credito_exportador: {
    name: "IVA Débito / Crédito Exportador",
    label: "Iva-T",
  },
  retencion_extranjeros: { name: "Retención Extranjeros", label: "Ret-Ex" },
  retencion_boletas_servicio: {
    name: "Retención Boletas de Servicio",
    label: "Fond-Rend",
  },
  patentes_municipales: { name: "Patentes municipales", label: "Pat-Mun" },
  contribuciones: { name: "Contribuciones", label: "Cont" },
  impuesto_a_la_renta: { name: "Impuesto a la renta", label: "Imp-Rent" },
  contrato_arriendo: { name: "Contrato Arriendo", label: "Arriend" },
  membresia: { name: "Membresía", label: "Menbr" },
  contrato_cuentas_en_participacion: {
    name: "Contrato de Cuentas en Participación",
    label: "Contr",
  },
  garantias_entregadas: { name: "Garantías Entregadas", label: "Garant-Entr" },
  leasing: { name: "Leasing", label: "Leas" },
  nota_cobro: { name: "Nota de Cobro", label: "N-Cob" },
  juicio: { name: "Juicio", label: "Juic" },
  seguros: { name: "Seguros", label: "Seg" },
  deposito_a_plazo: { name: "Depósito a Plazo", label: "Dep-Pla" },
  fondo_mutuo: { name: "Fondo Mútuo", label: "Fon-Mut" },
  acciones: { name: "Acciones", label: "Acc" },
  fondo_inversion: { name: "Fondo de Inversión", label: "Fon-Inv" },
  bonos: { name: "Bonos", label: "Bono" },
  otros_instrumentos_financieros: {
    name: "Otros Instrumentos Financieros",
    label: "Otr-Inst",
  },
  suscripcion_derechos_acciones: {
    name: "Suscripción de Derechos / Acciones",
    label: "Sus-Der/Acc",
  },
  disminucion_capital: { name: "Disminución de Capital", label: "Dis-Cap" },
  dividendos_retiro_definitivo: {
    name: "Dividendos / Retiro Definitivo",
    label: "Div",
  },
  dividendos_retiro_provisorio: {
    name: "Dividendos / Retiro Provisorio",
    label: "Div",
  },
  comprobante_gastos_comunes: {
    name: "Comprobante Gastos Comunes",
    label: "Gas-Com",
  },
  donacion: { name: "Donación", label: "Don" },
  premios: { name: "Premios", label: "Prem" },
  multas_a_beneficio_fiscal: {
    name: "Multas a Beneficio Fiscal",
    label: "Mult",
  },
  permiso_circulacion: { name: "Permiso de Circulación", label: "Per-Cir" },
  pago_tarjeta_credito: { name: "Pago Tarjeta de Crédito", label: "Pago-TC" },
  cheque: { name: "Cheque", label: "Chec" },
  pago_por_un_tercero: { name: "Pago por un Tercero", label: "P-Ter" },
  efectivo: { name: "Efectivo", label: "Efec" },
  factoring: { name: "Factoring", label: "Fact" },
  sobregiro_cuenta_corriente: {
    name: "Sobregiro Cuenta Corriente",
    label: "Seb-CC",
  },
  impuestos_financieros: { name: "Impuestos Financieros", label: "Imp-Fin" },
  intereses_financieros: { name: "Intereses Financieros", label: "Int-Fin" },
  propinas: { name: "Propinas", label: "Prop" },
  movilizacion: { name: "Movilización", label: "Mov" },
  reunion_negocios: { name: "Reunión de Negocios", label: "Reu-Neg" },
  gastos_varios: { name: "Gastos Varios", label: "Gas-Var" },
  gasto_cliente: { name: "Gasto de Cliente", label: "Gas-Cli" },
  tipo_cambio: { name: "Tipo Cambio", label: "Tip-Cam" },
  diferencia_de_pago: { name: "Diferencia de Pago", label: "Dif-Pag" },
  diferencia_de_tipo_de_cambio: { name: "Diferencia de Tipo de Cambio", label: "Dif-TC" },
  diferenciadetipodecambio: { name: "Diferencia de Tipo de Cambio", label: "Dif-TC" },
  otros_ingresos: { name: "Otros Ingresos", label: "Otr" },
  cheque_por_cobrar: { name: "Cheque", label: "Cheque" },
  cheque_por_pagar: { name: "Cheque", label: "Cheque" },
};

export const DOCUMENT_STATE = {
  PENDIENTE: 'PENDIENTE',
  REGISTRO: 'REGISTRO'
}